
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Contact } from '../../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { isValidPhone, phonePlaceholder } from './phone';

@Component({
  components: { vSelect },
})
export default class TabMain extends Vue {
  @Prop({ required: true })
  readonly availableSalutations!: string[];
  @Prop({ default: false })
  readonly contact!: Contact;

  isValidPhone = isValidPhone;
  phonePlaceholder = phonePlaceholder;

  get uid(): string {
    return (this as any)._uid;
  }
}
